import moment from 'moment'

const getters = {
  firstStepIsValid: state => {
    return state.selectedCountry && (window.isAdmin ? state.selectedUser : true)
  },
  has5RPrinters: (state, getters) => {
    return true
  },
  has6RPrinters: (state, getters) => {
    return true
  },
  has8RPrinters: (state, getters) => {
    return true
  },
  kioskHas5RPrinters: state => {
    return state.kiosk.smallPrintersNew['305 Printer 5R'] ||
      state.kiosk.smallPrintersNew['6900 new 5R']
  },
  kioskHas6RPrinters: state => {
    return state.kiosk.smallPrintersNew['305 Printer 6R'] ||
      state.kiosk.smallPrintersNew['6900 new 6R'] ||
      state.kiosk.smallPrintersRefurbished['6800 ref 6R'] ||
      state.kiosk.smallPrintersRefurbished['6850 ref 6R']
  },
  kioskHas8RPrinters: state => {
    return state.kiosk.largePrintersNew['88xx NEW'] ||
      state.kiosk.largePrintersNew['D4600 NEW'] ||
      state.kiosk.largePrintersRefurbished['8800 ref'] ||
      state.kiosk.largePrintersRefurbished['8810 ref'] ||
      state.kiosk.largePrintersRefurbished['D4000 ref']
  },
  apexHas5RPrinters: state => {
    return state.apex.smallPrintersNew['7000 NEW 5R'] ||
      state.apex.smallPrintersRefurbished['7000 ref'] ||
      state.apex.smallPrintersRefurbished['7015 ref']
  },
  apexHas6RPrinters: state => {
    return state.apex.smallPrintersNew['7000 NEW 6R']
  },
  apexHas8RPrinters: state => {
    return state.apex.largePrintersNew['88xx NEW'] ||
      state.apex.largePrintersNew['D4600 NEW'] ||
      state.apex.largePrintersRefurbished['8800 ref'] ||
      state.apex.largePrintersRefurbished['8810 ref'] ||
      state.apex.largePrintersRefurbished['D4000 ref']
  },
  standaloneHas5RPrinters: state => {
    return state.standalone.smallPrintersNew['305 Printer 5R'] ||
      state.standalone.smallPrintersNew['6900 new 5R'] ||
      state.standalone.smallPrintersNew['7000 NEW 5R']  ||
      state.standalone.smallPrintersRefurbished['7000 ref'] ||
      state.standalone.smallPrintersRefurbished['7015 ref']
  },
  standaloneHas6RPrinters: state => {
    return state.standalone.smallPrintersNew['305 Printer 6R'] ||
      state.standalone.smallPrintersNew['6900 new 6R'] ||
      state.standalone.smallPrintersNew['7000 NEW 6R'] ||
      state.standalone.smallPrintersRefurbished['6800 ref'] ||
      state.standalone.smallPrintersRefurbished['6850 ref']
  },
  standaloneHas8RPrinters: state => {
    return state.standalone.largePrintersNew['88xx NEW'] ||
      state.standalone.largePrintersNew['D4600 NEW'] ||
      state.standalone.largePrintersRefurbished['8800 ref'] ||
      state.standalone.largePrintersRefurbished['8810 ref'] ||
      state.standalone.largePrintersRefurbished['D4000 ref']
  },
  postData: state => {
    let equipment = {
      kiosk: null,
      apex: null,
      standalone: null,
    }
    if (state.equipment.includes('kiosk')) {
      equipment.kiosk = {
        'headunits_new': state.kiosk.headunits.includes('new'),
        'h_n_g20': state.kiosk.headunitsNew['G20'],
        'h_n_janus': state.kiosk.headunitsNew['Janus'],
        'headunits_refurbished': state.kiosk.headunits.includes('refurbished'),
        'h_r_g4xl_1_ref': state.kiosk.headunitsRefurbished['G4XL 1 ref'],
        'h_r_g4xl_2_ref': state.kiosk.headunitsRefurbished['G4XL 2 ref'],
        'printers_4_new': state.kiosk.smallPrinters.includes('new'),
        'p_4_n_305_6r': state.kiosk.smallPrintersNew['305 Printer 6R'],
        'p_4_n_305_5r': state.kiosk.smallPrintersNew['305 Printer 5R'],
        'p_4_n_6900_6r': state.kiosk.smallPrintersNew['6900 new 6R'],
        'p_4_n_6900_5r': state.kiosk.smallPrintersNew['6900 new 5R'],
        'printers_4_refurbished': state.kiosk.smallPrinters.includes('refurbished'),
        'p_4_r_6800_6r': state.kiosk.smallPrintersRefurbished['6800 ref 6R'],
        'p_4_r_6850_6r': state.kiosk.smallPrintersRefurbished['6850 ref 6R'],
        'printers_8_new': state.kiosk.largePrinters.includes('new'),
        'p_8_n_88xx': state.kiosk.largePrintersNew['88xx NEW'],
        'p_8_n_d4600': state.kiosk.largePrintersNew['D4600 NEW'],
        'printers_8_refurbished': state.kiosk.largePrinters.includes('refurbished'),
        'p_8_r_8800': state.kiosk.largePrintersRefurbished['8800 ref'],
        'p_8_r_8810': state.kiosk.largePrintersRefurbished['8810 ref'],
        'p_8_r_d4000': state.kiosk.largePrintersRefurbished['D4000 ref'],
        'cabinets_new': state.kiosk.cabinets.includes('new'),
        'cabinet_skipper_17': state.kiosk.cabinetsNew['Skipper 17'],
        'cabinet_skipper_24': state.kiosk.cabinetsNew['Skipper 24'],
        'cabinet_tranformer_24': state.kiosk.cabinetsNew['Transformer 24'],
        'cabinet_6900_cabinet_17': state.kiosk.cabinetsNew['6900 Cabinet 17'],
        'cabinets_refurbished': state.kiosk.cabinets.includes('refurbished'),
        'cabinet_transformer_ref_17': state.kiosk.cabinetsRefurbished['Transformer ref 17'],
        'cabinet_transformer_ref_24': state.kiosk.cabinetsRefurbished['Transformer ref 24'],
      }
    }
    if (state.equipment.includes('apex')) {
      equipment.apex = {
        'headunits_new': state.apex.headunitsNew,
        'headunits_refurbished': state.apex.headunitsRefurbished,
        'printers_4_new': state.apex.smallPrinters.includes('new'),
        'p_4_n_7000_new_6r': state.apex.smallPrintersNew['7000 NEW 6R'],
        'p_4_n_7000_new_5r': state.apex.smallPrintersNew['7000 NEW 5R'],
        'printers_4_refurbished': state.apex.smallPrinters.includes('refurbished'),
        'p_4_r_7000_ref': state.apex.smallPrintersRefurbished['7000 ref'],
        'p_4_r_7015_ref': state.apex.smallPrintersRefurbished['7015 ref'],
        'printers_8_new': state.apex.largePrinters.includes('new'),
        'p_8_n_88xx': state.apex.largePrintersNew['88xx NEW'],
        'p_8_n_d4600': state.apex.largePrintersNew['D4600 NEW'],
        'printers_8_refurbished': state.apex.largePrinters.includes('refurbished'),
        'p_8_r_8800': state.apex.largePrintersRefurbished['8800 ref'],
        'p_8_r_8810': state.apex.largePrintersRefurbished['8810 ref'],
        'p_8_r_d4000': state.apex.largePrintersRefurbished['D4000 ref'],
        'cabinet_apex_30': state.apex.cabinets['APEX 30'],
        'cabinet_apex_40': state.apex.cabinets['APEX 40'],
        'cabinet_apex_70': state.apex.cabinets['APEX 70'],
      }
    }
    if (state.equipment.includes('standalone')) {
      equipment.standalone = {
        'printers_4_new': state.standalone.smallPrinters.includes('new'),
        'p_4_n_305_6r': state.standalone.smallPrintersNew['305 Printer 6R'],
        'p_4_n_305_5r': state.standalone.smallPrintersNew['305 Printer 5R'],
        'p_4_n_6900_new_6r': state.standalone.smallPrintersNew['6900 new 6R'],
        'p_4_n_6900_new_5r': state.standalone.smallPrintersNew['6900 new 5R'],
        'p_4_n_7000_new_6r': state.standalone.smallPrintersNew['7000 NEW 6R'],
        'p_4_n_7000_new_5r': state.standalone.smallPrintersNew['7000 NEW 5R'],
        'printers_4_refurbished': state.standalone.smallPrinters.includes('refurbished'),
        'p_4_r_7000_ref': state.standalone.smallPrintersRefurbished['7000 ref'],
        'p_4_r_7015_ref': state.standalone.smallPrintersRefurbished['7015 ref'],
        'p_4_r_6800_ref': state.standalone.smallPrintersRefurbished['6800 ref'],
        'p_4_r_6850_ref': state.standalone.smallPrintersRefurbished['6850 ref'],
        'printers_8_new': state.standalone.largePrinters.includes('new'),
        'p_8_n_88xx': state.standalone.largePrintersNew['88xx NEW'],
        'p_8_n_d4600': state.standalone.largePrintersNew['D4600 NEW'],
        'printers_8_refurbished': state.standalone.largePrinters.includes('refurbished'),
        'p_8_r_8800': state.standalone.largePrintersRefurbished['8800 ref'],
        'p_8_r_8810': state.standalone.largePrintersRefurbished['8810 ref'],
        'p_8_r_d4000': state.standalone.largePrintersRefurbished['D4000 ref'],
        'connection_pc': state.standalone.connections.includes('pc'),
        'connection_mac': state.standalone.connections.includes('mac'),
      }
    }

    return {
      trial: {
        'user_id': state.selectedUser ? state.selectedUser.id : null,
        'country_id': state.selectedCountry ? state.selectedCountry.id : null,
        'currency': state.currency,
        'distributor_id': state.selectedDistributor ? state.selectedDistributor.id : null,
        'start_date': state.startDate ? moment(state.startDate).format('YYYY-MM-DD') : '',
        'test_period': state.testPeriod,
        'stores': state.storesNumber,
        'software_version': state.software,
        'rbm_units': state.rbm,
        'printing_devices': state.printingDevices,
        'website': state.companyWebsite,
        'promo_general_moments': state.kodakmoments,
        'promo_general_branding_co': state.co,
        'promo_general_branding_company': state.company,
        'targetgroup': state.targetgroup,
        'original_currency': state.originalCurrency,
        'exchanges_to': state.exchangesTo,
      },
      key_account: {
        'name': state.name,
        'type': state.type,
        'sales_name': state.sales.name,
        'sales_phone_number': state.sales.phone,
        'sales_email': state.sales.email,
        'marketing_name': state.marketing.name,
        'marketing_phone_number': state.marketing.phone,
        'marketing_email': state.marketing.email,
        'stores': state.stores.number,
        'potential_rollouts': state.stores.potentialRollouts,
        'stores_description': state.stores.description,
      },
      equipments: state.equipment,
      equipment,
      social_media_communication: state.communicationSM,
      pos_communications: state.communicationPOS,
      key_account_communications: state.communicationKA,
      small_products: state.products5R,
      middle_products: state.products6R,
      large_products: state.products8R,
      creative_products: state.productsCreative,
      promos: state.promosDuringTest,
      roll_out_promotions: state.rollOutPromotions,
    }
  },
  alreadyFetchedSmallProducts: state => {
    return Object.keys(state.products5R).length > 0
  },
  alreadyFetchedMiddleProducts: state => {
    return Object.keys(state.products6R).length > 0
  },
  alreadyFetchedLargeProducts: state => {
    return Object.keys(state.products8R).length > 0
  },
  currencyLabel: state => {
    return state.currency === 'euro' ? '€' : '$'
  },

  existingPosCommunication: state => communication => {
    return state.trialPosCommunications.find(eCommunication => eCommunication.id === communication.id)
  },
  existingKaCommunication: state => communication => {
    return state.trialKaCommunications.find(eCommunication => eCommunication.id === communication.id)
  },
  existingSmCommunication: state => communication => {
    return state.trialSmCommunications.find(eCommunication => eCommunication.id === communication.id)
  },
  existingPromo: state => promo => {
    return state.trialPromos.find(ePromo => ePromo.id === promo.id)
  },

  posCommunicationIsChecked: state => communication => {
    return state.communicationPOS.includes(communication.id)
  },
  kaCommunicationIsChecked: state => communication => {
    return state.communicationKA.includes(communication.id)
  },
  smCommunicationIsChecked: state => communication => {
    return state.communicationSM.includes(communication.id)
  },
  promoIsChecked: state => promo => {
    return state.promosDuringTest.includes(promo.id)
  },

  posCommunicationHasDocuments: state => communication => {
    const existingCom = state.trialPosCommunications.find(eCommunication => eCommunication.id === communication.id)
    return existingCom ? existingCom.documents.length > 0 : false
  },
  kaCommunicationHasDocuments: state => communication => {
    const existingCom = state.trialKaCommunications.find(eCommunication => eCommunication.id === communication.id)
    return existingCom ? existingCom.documents.length > 0 : false
  },
  smCommunicationHasDocuments: state => communication => {
    const existingCom = state.trialSmCommunications.find(eCommunication => eCommunication.id === communication.id)
    return existingCom ? existingCom.documents.length > 0 : false
  },
  promoHasDocuments: state => promo => {
    const existingPromo = state.trialPromos.find(ePromo => ePromo.id === promo.id)
    return existingPromo ? existingPromo.documents.length > 0 : false
  },
}

export default getters



// WEBPACK FOOTER //
// ./resources/js/store/getters.js